import { render } from "./chat-container.vue?vue&type=template&id=4b8f7b26"
import script from "./chat-container.vue?vue&type=script&lang=js"
export * from "./chat-container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__